import * as types from '../../../../types/masters/styles/caratage/caratageTypes';
import * as api from '../../../../../api/masters/styles/caratage/caratageApi';

export const fetchCaratages = () => async (dispatch) => {
  dispatch({ type: types.FETCH_CARATAGE_REQUEST });
  try {
    const data = await api.fetchCaratages();
    dispatch({ type: types.FETCH_CARATAGE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_CARATAGE_FAILURE, payload: error.message });
  }
};

export const addCaratage = (caratage) => async (dispatch) => {
  dispatch({ type: types.ADD_CARATAGE_REQUEST });
  try {
    const res = await api.addCaratage(caratage);
    dispatch({ type: types.ADD_CARATAGE_SUCCESS, payload: res });
    dispatch(fetchCaratages());
  } catch (error) {
    dispatch({ type: types.ADD_CARATAGE_FAILURE, payload: error.response?.data?.message || error.message });
  }
};

export const updateCaratage = (id, caratage) => async (dispatch) => {
  dispatch({ type: types.UPDATE_CARATAGE_REQUEST });
  try {
    const res = await api.updateCaratage(id, caratage);
    dispatch({ type: types.UPDATE_CARATAGE_SUCCESS, payload: res });
    dispatch(fetchCaratages());
  } catch (error) {
    dispatch({ type: types.UPDATE_CARATAGE_FAILURE, payload: error.response?.data?.message || error.message });
  }
};

export const deleteCaratage = (id) => async (dispatch) => {
  dispatch({ type: types.DELETE_CARATAGE_REQUEST });
  try {
    await api.deleteCaratage(id);
    dispatch({ type: types.DELETE_CARATAGE_SUCCESS, payload: id });
    dispatch(fetchCaratages());
  } catch (error) {
    dispatch({ type: types.DELETE_CARATAGE_FAILURE, payload: error.response?.data?.message || error.message });
  }
};

export const setCaratageEdit = (caratage) => ({
  type: types.SET_CARATAGE_EDIT,
  payload: caratage,
});

export const clearCaratageEdit = () => ({
  type: types.CLEAR_CARATAGE_EDIT,
}); 